import React, {useEffect, useState} from 'react'
import {BASE_URL} from '../utils/commonUrl';
import Layout from '../components/Layout'
import axios from 'axios';
import {useDispatch, useSelector} from 'react-redux'
import AssestmentTitleIndicatorForm from "./forms/AssestmentTitleIndicatorForm";
import {Button} from "primereact/button";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {fetchAssestmentTitleIndicator} from "../redux/features/assestmentTitleIndicator.feature";
import { textAlign } from '@mui/system';
import {FilterMatchMode, FilterOperator} from "primereact/api";
import {InputText} from "primereact/inputtext";

const AssestmentTitleIndicator = () => {    
    const dispatch = useDispatch();
    const state = useSelector((state => state["assestmenttitleindicator"]))
    const [modal, setModal] = useState(false)
    const [start, setFirst] = useState(0);
    const [activeAssestmentTitleNames, setactiveAssestmentTitleNames] = useState([]);// DropDown
    const [isLoading, setIsLoading] = useState(false);
	
    const [assestmentTitleIndicatorItem, setAssestmentTitleIndicatorItem] = useState({
					assestmentTitleIndicatorID: 0,
					 assestmentTitleID: 0,
					 indicatorSequenceNo: "",
					 indicatorTitle: "",
					 indicatorTitleBangla: "",
					 indicatorValue: 0,
					 active: true,
    })

    useEffect(() => {
        dispatch(fetchAssestmentTitleIndicator())
        AssestmentTitleIndicatorActiveNames()
        initFilters1();
    }, [])

    const AssestmentTitleIndicatorActiveNames = async () => {
        try {
            const url = BASE_URL + '/api/assestmentTitle/GetActiveList'
            const response = await axios.get(url)
            if (response.status === 200) {
                const optionList = [{value: '-1', label: 'Please Select Assestment Title'}];
                response.data.map(val => optionList.push({value: val.assestmentTitleID, label: val.assestmentTitleName}))

                setactiveAssestmentTitleNames(optionList)
            }

        } catch (e) {
            console.log(e)
        }

    }
    const onSubmit = async data => {
        console.log(data);
        try {
            setIsLoading(true)
            const url = BASE_URL + "/api/assestmentTitleIndicator";
            const response = await axios.post(url, data);
            setIsLoading(false)
            if (response.status === 200) {
                dispatch(fetchAssestmentTitleIndicator())
                setAssestmentTitleIndicatorItem({
                    assestmentTitleIndicatorID: 0,
					 assestmentTitleID: 0,
					 indicatorSequenceNo: "",
					 indicatorTitle: "",
					 indicatorTitleBangla: "",
					 indicatorValue: 0,
					 active: true,
                })
                setModal(!modal)
            }
        } catch (e) {
            console.log(e)
            setIsLoading(false)
        }


    }

    const onHide = () => {
        setModal(!modal)
        setAssestmentTitleIndicatorItem({
            assestmentTitleIndicatorID: 0,
					 assestmentTitleID: 0,
					 indicatorSequenceNo: "",
					 indicatorTitle: "",
					 indicatorTitleBangla: "",
					 indicatorValue: 0,
					 active: true,
        })
    }
	
    const editGridData = data => {
        setAssestmentTitleIndicatorItem({
            assestmentTitleIndicatorID: data.assestmentTitleIndicatorID,
            assestmentTitleID: data.assestmentTitleID,
            indicatorSequenceNo: data.indicatorSequenceNo,
            indicatorTitle: data.indicatorTitle,
            indicatorTitleBangla: data.indicatorTitleBangla,
            indicatorValue: data.indicatorValue,
            active: data.active,
        });
        setModal(!modal);
    }

    const deleteGridData = data => {
        //setDeleteassestmentTitleIndicatorItem({quarterName:data.quarterName,quarterId:data.quarterID})
        //setDeleteProductDialog(true)
    }


    //filter begin

    const [filters1, setFilters1] = useState(null);
    const [globalFilterValue1, setGlobalFilterValue1] = useState('');

    const onGlobalFilterChange1 = (e) => {
        const value = e.target.value;
        let _filters1 = {...filters1};
        _filters1['global'].value = value;
        setFilters1(_filters1);
        setGlobalFilterValue1(value);
    }



    const initFilters1 = () => {
        setFilters1({
            'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
            'indicatorSequenceNo': {
                operator: FilterOperator.AND,
                constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
            },
            'assestmentTitle.assestmentTitleName': {
                operator: FilterOperator.AND,
                constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
            },
            'indicatorTitle': {
                operator: FilterOperator.AND,
                constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
            },
            'indicatorTitleBangla': {
                operator: FilterOperator.AND,
                constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
            },
            'active': {
                operator: FilterOperator.AND,
                constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
            },
        });
        setGlobalFilterValue1('');
    }

    const clearFilter1 = () => {
        initFilters1();
    }


    //filter end



    const actionBodyTemplate = (rowData) => {
        return (
            <>
                <Button icon="pi pi-pencil" className="p-button-rounded p-button-success mr-2"
                        onClick={() => editGridData(rowData)}/>
                &nbsp;   <Button icon="pi pi-trash" className="p-button-rounded p-button-warning"
                                 onClick={() => deleteGridData(rowData)}/>
            </>
        );
    }

    const header = (
        <div className="table-header">
            <div className='d-flex justify-content-between'>
                <div>
                    <Button type="button" icon="pi pi-filter-slash" label="Clear" className="p-button-outlined" onClick={clearFilter1}/>
                    <span className="p-input-icon-left"> <i className="pi pi-search"/>
                    <InputText value={globalFilterValue1} onChange={onGlobalFilterChange1} placeholder="Keyword Search"/>
                </span>
                </div>
                <button type='button' onClick={() => setModal(!modal)} className='btn btn-primary'>Add Assestment TitleIndicator
                </button>
            </div>
        </div>
    );

    const footer =`In total there are ${state.assestmenttitleindicators ? state.assestmenttitleindicators.length : 0} assestmentTitleIndicator.`;

    const _isActiveColumn = (rowData) => {
        return <div>{rowData.active ? <>Active</> : <>Inactive</>}</div>
    }

    const Table = (
        <DataTable value={state.assestmenttitleindicators}
                   showGridlines
                   dataKey="assestmentTitleIndicatorID" filters={filters1} filterDisplay="menu"
                   globalFilterFields={['assestmentTitle.assestmentTitleName', 'indicatorSequenceNo','indicatorTitle','indicatorTitleBangla','active']}

                   header={header} footer={footer} paginator rows={7} first={start}
                   paginatorTemplate="RowsPerPageDropdown PageLinks FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink">
            <Column field="assestmentTitleIndicatorID" header="assestmentTitleIndicatorID" hidden={true}/>
            <Column field="assestmentTitle.assestmentTitleName" header="Type"/>
            <Column field='indicatorSequenceNo' header="Sequence No"/>
            <Column field='indicatorTitle' header="Title"/>
            <Column field='indicatorTitleBangla' header="IndicatorTitleBangla" hidden={true}/>
            <Column field='indicatorValue' header="IndicatorValue" hidden={true}/>
            <Column field='active' header="Active" body={_isActiveColumn}/>
            <Column body={actionBodyTemplate} header="Action" exportable={false} style={{minWidth: '4rem', textAlign:"center"}}/>
        </DataTable>
    )
	
    return (
        <Layout>
            <AssestmentTitleIndicatorForm
                isLoading={isLoading}
                setactiveAssestmentTitleNames={activeAssestmentTitleNames}
                assestmentTitleIndicatorID={assestmentTitleIndicatorItem.assestmentTitleIndicatorID}
                assestmentTitleID={assestmentTitleIndicatorItem.assestmentTitleID}
                indicatorSequenceNo={assestmentTitleIndicatorItem.indicatorSequenceNo}
                indicatorTitle={assestmentTitleIndicatorItem.indicatorTitle}
                indicatorTitleBangla={assestmentTitleIndicatorItem.indicatorTitleBangla}
                indicatorValue={assestmentTitleIndicatorItem.indicatorValue}
                active={assestmentTitleIndicatorItem.active}
                modal={modal}
                onSubmit={onSubmit}
                onHide={onHide}/>
            {Table}
        </Layout>
    )
}

export default AssestmentTitleIndicator